// Lightweight, self-contained hero slider — no dependency on Dawn's slideshow-component.
class YassineHeroSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-slider-track]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.prevButton = this.querySelector('[data-slider-prev]');
    this.nextButton = this.querySelector('[data-slider-next]');
    this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
    this.currentIndex = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = (parseInt(this.dataset.speed, 10) || 6) * 1000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  connectedCallback() {
    if (!this.track || this.slides.length === 0) return;

    if (this.slides.length <= 1) {
      if (this.prevButton) this.prevButton.hidden = true;
      if (this.nextButton) this.nextButton.hidden = true;
      return;
    }

    this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true));
    this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true)));

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());

    this.update();
    this.play();
  }

  goTo(index, isUserAction) {
    const total = this.slides.length;
    this.currentIndex = (index + total) % total;
    this.update();
    if (isUserAction) this.play();
  }

  update() {
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    this.slides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.setAttribute('aria-hidden', String(!isActive));
      slide.querySelectorAll('a, button').forEach((el) => {
        if (isActive) {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', '-1');
        }
      });
    });

    this.dots.forEach((dot, index) => {
      const isActive = index === this.currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', String(isActive));
    });
  }

  play() {
    this.pause();
    if (!this.autoplay || this.reducedMotion) return;
    this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
  }

  pause() {
    if (this.timer) clearInterval(this.timer);
  }

  disconnectedCallback() {
    this.pause();
  }
}

customElements.define('yassine-hero-slider', YassineHeroSlider);
